// extracted by mini-css-extract-plugin
var _1 = "TaskSummary-moduleTaskSummary__IOPga";
var _2 = "TaskSummary-moduletitle__QkhRa";
export { _1 as "TaskSummary", _2 as "title" }
